/* eslint-disable react/prop-types */
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { switchUser, logout } from '../services/axiosAuth';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { login as loginAction, logout as logoutAction } from '../reducers/authActions';
import Spinner from '../components/Utils/Spinner.jsx';
import Message from './Part/Message.jsx';

class SwitchUser extends Component {
  state = {
    error: null,
    success: null,
    redirect: false,
    showMessage: false,
  };

  componentDidMount() {
    logout().then(() => {
      this.props.dispatch(logoutAction());
      switchUser(this.props.match.params.hash)
        .then((response) => {
          this.props.dispatch(loginAction(response.data.token));
          this.props.history.push('/');
        })
        .catch((e) => {
          if (e?.response?.status === 401) {
            this.setState({
              error: this.props.intl.formatMessage({
                id: 'Something went wrong, try again later.',
              }),
              showMessage: true,
            });
          }
        });
    });
  }

  hideMessage = () => {
    this.setState({ showMessage: false });
  };

  render() {
    return (
      <div>
        {this.state.error && <Message message={this.state.error} open={this.state.showMessage} onClick={this.hideMessage} type='error' />}
        <p className='login-help-info'>
          <FormattedMessage id='Wait, we are moving you to the partners zone' />
        </p>
        <div style={{ height: '200px', paddingTop: '100px', margin: 'auto' }}>
          {!this.state.error && <Spinner className='standalone' />}
        </div>
      </div>
    );
  }
}

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state.authReducer)
);

export default enhance(SwitchUser);
